import React from "react";

const AltHeader = ({HeaderTitle, HeaderDesc}) => (
    <header className="py-24 text-white bg-gradient">
        <div className="container">
            <h1 className="text-4xl font-extrabold">{HeaderTitle}</h1>
            <p>{HeaderDesc}</p>
        </div>
    </header>
)

export default AltHeader